import React from "react";
import { useStore } from "effector-react";
import { Pause, PlayArrow } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { Box, Button, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, } from "@material-ui/core";
import { Add, Delete, Edit } from "@material-ui/icons";
import { createWebSchedule, deleteWebSchedule, getWebSchedules, } from "frontend/src/api/web-schedules";
import { queryClient } from "frontend/src/domain/query-client";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { paths } from "frontend/src/pages/paths";
import { $activeWebSchedule, playWebScheduleAttempted, stopWebScheduleAttempted, } from "frontend/src/features/play-web-schedule";
var cacheKey = "web-schedules";
var path = paths.business.owner;
var weekdayLabels = [
    { bit: 1, label: "Пн" },
    { bit: 2, label: "Вт" },
    { bit: 4, label: "Ср" },
    { bit: 8, label: "Чт" },
    { bit: 16, label: "Пт" },
    { bit: 32, label: "Сб" },
    { bit: 64, label: "Вс" },
];
var formatDays = function (value) {
    if (value === 127) {
        return "Пн-Вс";
    }
    if ((value & 31) === 31 && (value & 96) === 0) {
        return "Пн-Пт";
    }
    if ((value & 96) === 96 && (value & 31) === 0) {
        return "Сб-Вс";
    }
    return weekdayLabels
        .filter(function (day) { return (value & day.bit) > 0; })
        .map(function (day) { return day.label; })
        .join(", ");
};
var ScheduleRows = function (_a) {
    var rows = _a.rows, type = _a.type;
    if (rows.length === 0) {
        return React.createElement(Typography, { variant: "caption" }, "\u041D\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043D\u043E");
    }
    return (React.createElement(Box, null, rows.map(function (row, index) { return (React.createElement(Typography, { key: index, display: "block", variant: "caption" },
        formatDays(row.daysEnabled),
        " ",
        row.timeStart,
        "-",
        row.timeEnd,
        " · ",
        type === "music"
            ? row.playlistTitle || "\u041F\u043B\u0435\u0439\u043B\u0438\u0441\u0442 #" + row.playlistId
            : "" + (row.trackTitle || "\u0420\u043E\u043B\u0438\u043A #" + row.trackId) + (row.repeatIntervalMinutes
                ? " \u00B7 \u043A\u0430\u0436\u0434\u044B\u0435 " + row.repeatIntervalMinutes + " \u043C\u0438\u043D"
                : ""))); })));
};
export var WebSchedulesPage = function () {
    var _a, _b;
    var history = useHistory();
    var activeWebSchedule = useStore($activeWebSchedule);
    var schedules = useQuery(cacheKey, getWebSchedules);
    var create = useMutation(createWebSchedule, {
        onSuccess: function (schedule) {
            queryClient.invalidateQueries(cacheKey);
            history.push(path.schedules.edit(schedule.id));
        },
    });
    var remove = useMutation(deleteWebSchedule, {
        onSuccess: function () { return queryClient.invalidateQueries(cacheKey); },
    });
    return (React.createElement(BusinessOwnerLayout, null,
        React.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center" },
            React.createElement(Typography, { variant: "h5" }, "\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442\u043E\u0432"),
            React.createElement(Button, { color: "primary", variant: "contained", startIcon: React.createElement(Add, { fontSize: "small" }), disabled: create.isLoading, onClick: function () { return create.mutate(); } }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C")),
        React.createElement(Box, { mt: 2 }, ((_a = schedules.data) === null || _a === void 0 ? void 0 : _a.length) === 0 ? (React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(Typography, null, "\u041F\u043E\u043A\u0430 \u043D\u0435\u0442 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0439."))) : (React.createElement(TableContainer, { component: Paper },
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                        React.createElement(TableCell, null, "\u041C\u0443\u0437\u044B\u043A\u0430\u043B\u044C\u043D\u044B\u0435 \u043E\u043A\u043D\u0430"),
                        React.createElement(TableCell, null, "\u0420\u043E\u043B\u0438\u043A\u0438"),
                        React.createElement(TableCell, null, "\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435"),
                        React.createElement(TableCell, { width: "5%" }),
                        React.createElement(TableCell, { width: "5%" }),
                        React.createElement(TableCell, { width: "5%" }))),
                React.createElement(TableBody, null, ((_b = schedules.data) !== null && _b !== void 0 ? _b : []).map(function (schedule) { return (React.createElement(TableRow, { key: schedule.id },
                    React.createElement(TableCell, null, schedule.title),
                    React.createElement(TableCell, null,
                        React.createElement(ScheduleRows, { rows: schedule.musicWindows, type: "music" })),
                    React.createElement(TableCell, null,
                        React.createElement(ScheduleRows, { rows: schedule.advertisements, type: "ad" })),
                    React.createElement(TableCell, null, (activeWebSchedule === null || activeWebSchedule === void 0 ? void 0 : activeWebSchedule.id) === schedule.id
                        ? "Сейчас играет"
                        : ""),
                    React.createElement(TableCell, null, (activeWebSchedule === null || activeWebSchedule === void 0 ? void 0 : activeWebSchedule.id) === schedule.id ? (React.createElement(Tooltip, { title: "Остановить" },
                        React.createElement(IconButton, { size: "small", onClick: function () { return stopWebScheduleAttempted(); } },
                            React.createElement(Pause, null)))) : (React.createElement(Tooltip, { title: "Запустить" },
                        React.createElement(IconButton, { size: "small", onClick: function () {
                                return playWebScheduleAttempted({
                                    id: schedule.id,
                                    title: schedule.title,
                                });
                            } },
                            React.createElement(PlayArrow, null))))),
                    React.createElement(TableCell, null,
                        React.createElement(Tooltip, { title: "Редактировать" },
                            React.createElement(IconButton, { size: "small", onClick: function () { return history.push(path.schedules.edit(schedule.id)); } },
                                React.createElement(Edit, null)))),
                    React.createElement(TableCell, null,
                        React.createElement(Tooltip, { title: "Удалить" },
                            React.createElement(IconButton, { size: "small", onClick: function () { return remove.mutate(schedule.id); } },
                                React.createElement(Delete, null)))))); }))))))));
};
